<template>
    <div class="setting-advanced-mass">
        <div class="module-item-style top-tool-bar">
            <div style="flex: 1;display: flex;">
                <el-date-picker
                        v-model="selectTime"
                        type="daterange"
                        @change="timeSelect"
                        :picker-options="pickerOptions"
                        range-separator="~"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="timestamp"
                >
                </el-date-picker>
                <el-input placeholder="请输入消息内容" v-model="searchVal" class="input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="searchFn"></el-button>
                </el-input>
            </div>
            <div class="wl-btn" @click="addNewMass">新建群发</div>
        </div>

        <div class="module-item-style">
            <el-table
                    :data="tableData"
                    v-loading="isLoading"
                    :header-cell-style="{background:'#f2f2f2'}"
                    :class="panelOpen ? 'detailShow' : ''"
                    style="border: 1px solid #ebeef5;width: 100%;">
                <el-table-column
                        label="群发时间"
                        width="180">
                    <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ $utils.timestampToTime(scope.row.sendTime) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        v-if="!panelOpen"
                        label="消息内容"
                        prop="textContent">
                    <template slot-scope="scope">
                        {{formatTrendEmoji(scope.row.textContent)}} <span v-if="scope.row.imgContent && scope.row.imgContent.length > 0">[图片消息]</span>
                    </template>
                </el-table-column>
                <el-table-column
                        style="min-width: 110px;"
                        prop="sourceQk"
                        label="客户来源">
                </el-table-column>
                <el-table-column width="150px" label="操作">
                    <template slot-scope="scope">
                        <el-button
                                class="tb-btn tb-btn-edit"
                                size="mini"
                                @click="handleEdit(scope.$index, scope.row)">详情
                        </el-button>
                        <el-button
                                class="tb-btn"
                                size="mini"
                                @click="handleDelete(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagenations
                    :class="panelOpen ? 'detailShow' : ''"
                    :total="total"
                    :size="pageSize"
                    @pageHandler="pageOperate">
            </pagenations>
        </div>

        <div class="detail-panel" v-show="panelOpen">
            <massDetail @closePanel="panelOpen = false" :msgDetail="msgDetail"></massDetail>
        </div>

        <el-dialog
                title="群发助手"
                :visible.sync="dialogVisible"
                width="900px">
            <mass :dialogVisible="dialogVisible" @closeDialog="closeDialog"></mass>
        </el-dialog>
    </div>
</template>

<script>
    import pagenations from '@/components/pagenations/pagenations'
    import mass from './mass/newMass'
    import massDetail from './mass/massDetail'
    import emojiData from '@/libs/emoji/emoji-data'

    export default {
        name: "setting-advanced-mass",
        data() {
            return {
                msgDetail:{},
                dialogVisible: false,
                panelOpen: false,
                selectTime: '',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
                    }
                },
                searchVal: '',
                startTime: '',
                endTime: '',
                isLoading: false,
                total: 0,
                currentPage: 1,
                pageSize: 10,
                tableData: []
            }
        },
        components: {
            pagenations,
            mass,
            massDetail
        },
        created() {
        },
        mounted() {
            this.sendMassList()
        },
        methods: {
            /**
             * 【显示表情】
             */
            formatTrendEmoji(val) {
                let s_name = val;
                let s_img = [];
                let rules = /:([^:][a-z_\-]+):/g
                s_name.replace(rules, function ($1, $2) {
                    s_img.push($2);
                })
                for (let i = 0; i < s_img.length; i++) {
                    let str = ''
                    let r_str = ':' + s_img[i] + ':'
                    for (let key in emojiData) {
                        if (s_img[i] == key) {
                            let imgPath = require(`@/libs/emoji/images/${s_img[i]}.gif`)
                            str = s_name.replace(r_str, ' ['+emojiData[key][0]+'] ')
                        } else {
                            str = s_name.replace(r_str, r_str)
                        }
                        s_name = str
                    }
                }
                return s_name
            },
            searchFn(){
                this.currentPage = 1
                this.sendMassList()
            },
            sendMassList(){
                this.$http.sendMassListAPI({
                    keyword: this.searchVal,//       关键字
                    startTime: this.startTime,    // 开始时间
                    endTime:this.endTime,//       结束时间
                    pageNum: this.currentPage ,//      页数
                    pageSize: this.pageSize//      每页行数
                }).then(res => {
                    if(res.status == 1) {
                        this.tableData = res.data.list
                        this.total = res.data.total
                    }
                    console.log(res)
                })
            },
            closeDialog(){
                this.dialogVisible = false
                this.sendMassList()
            },
            addNewMass() {
                this.dialogVisible = true
            },
            /**
             * 时间选择
             */
            timeSelect() {
                console.log(this.selectTime)
                if (this.selectTime) {
                    this.startTime = this.selectTime[0] / 1000
                    let endTime = this.selectTime[1] / 1000
                    this.endTime = endTime + 24 * 60 * 60 - 1
                } else {
                    this.startTime = ''
                    this.endTime = ''
                }
                this.$nextTick(() => {
                    this.sendMassList()
                })
            },
            //  分页
            pageOperate(val) {
                if (val.type == 'currentChange') {
                    this.currentPage = val.val
                } else if (val.type == "sizeChange") {
                    this.pageSize = val.val
                }
                this.sendMassList()
            },
            handleEdit(index, row) {
                this.panelOpen = true
                this.msgDetail = row
                console.log(index, row);
            },
            handleDelete(index, row) {
                this.$confirm('将要进行删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    this.$http.delMassMsgAPI({
                        sendallId: row.id
                    }).then(res => {
                        if(res.status == 1){
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.sendMassList()
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                        console.log(res)
                    })
                }).catch(() => {

                });
                console.log(index, row);
            }

        }
    }
</script>

<style lang="scss">
    .setting-advanced-mass {
        .top-tool-bar {
            display: flex;
            justify-content: space-between;

            .el-date-editor--daterange.el-input__inner {
                width: 268px;
            }

            .input-with-select {
                width: 290px;
                margin-left: 15px;
            }
        }

        .tb-btn, .tb-btn:hover {
            background: none;
            border: 1px solid #999999;
            color: #666;
            border-radius: 6px;
            font-size: 12px;
            padding: 8px 15px;
            cursor: pointer;
            outline: none;

            &.tb-btn-edit, &.tb-btn-operate {
                border-color: #428efe;
                color: #428efe;
            }

            &.tb-btn-del {

            }
        }

        .tb-btn + .tb-btn {
            margin-left: 10px;
        }

        .detail-panel{
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            width: 40%;
            z-index: 99999;
            border-top: 1px solid #E5E5E5;
            border-left: 1px solid #E5E5E5;
            box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.3);
            transition: width .3s linear;
            background: #fff;
        }
        .detailShow{
            width: 55%!important;
            .el-pagination{
                white-space: initial;
            }
            .el-pager{
                margin-bottom: 10px;
            }
        }
    }
</style>